import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { CustomerVenueGroup } from "src/app/shared/models/CustomerVenueGroup.item";
import { MarketingBlastStatus } from "src/app/shared/models/enums/marketing-blast-status.enum";
import { MarketingBlast } from "src/app/shared/models/MarketingBlast.item";
import { MarketingTemplate } from "src/app/shared/models/MarketingTemplate.item";

@Component({
	selector: "app-blast-create-new",
	templateUrl: "./blast-create-new.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class BlastCreateNewComponent implements OnInit {
	@Input() blast: MarketingBlast;
	@Output() blastChange = new EventEmitter<MarketingBlast>();

	@Input() blastList: MarketingBlast[];
	@Output() blastListChange = new EventEmitter<MarketingBlast[]>();

	@Input() templateList: MarketingTemplate[];
	@Input() groupList: CustomerVenueGroup[];
	@Input() venueKey: number;

	@Output() onDeleteChange = new EventEmitter<string>();
	@Output() onSaveChange = new EventEmitter<MarketingBlast>();

	today: Date = new Date();

	view: number = 0; //0 - who; 1 - template; 2 - criteria
	constructor(public app: AppService, private focuslink: FocuslinkService, private localStorage: LocalDataStoreService) {}

	ngOnInit(): void {
		this.blast.sendDateDateFormat = moment(this.blast.sendDate).toDate();
	}

	save() {
		this.blast.sendDate = moment(this.blast.sendDateDateFormat).format();
		this.focuslink.marketingBlastPost(this.venueKey, this.blast);
		this.blastChange.emit(undefined);

		const idx = this.blastList.findIndex((i) => i.sk === this.blast.sk);
		if (idx !== -1) {
			this.blastList[idx] = this.blast;
		} else {
			this.blastList.push(this.blast);
		}
		this.onSaveChange.emit(this.blast);
	}

	saveWithoutScheduling() {
		this.app.confirmation.confirm({
			message: `This Blast will be saved but NOT scheduled for send. Continue?`,
			accept: async () => {
				this.blast.status = MarketingBlastStatus.UNSCHEDULED;
				this.save();
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	saveAndSchedule() {
		this.app.confirmation.confirm({
			message: `This Blast will be scheduled for ${moment(this.blast.sendDate).format("l LT")}, do you want to continue?`,
			accept: async () => {
				this.blast.status = MarketingBlastStatus.SCHEDULED;
				this.save();
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	blastDelete(rec: MarketingBlast) {
		this.focuslink.marketingBlastDelete(this.venueKey, rec.sk);
		this.blastList.splice(
			this.blastList.findIndex((i) => i.sk === rec.sk),
			1
		);
		this.onDeleteChange.emit(rec.sk);
		this.blastChange.emit(undefined);
	}
}
